export class Link {

  public href: string;

  constructor (href: string){
    this.href = href;
  }

}
